import Vue from 'vue'

// 有赞ui
import {
    ActionSheet,
    NavBar,
    Overlay,
    RadioGroup,
    Radio,
    Tabbar,
    TabbarItem,
    NoticeBar,
    Tab,
    Tabs,
    Grid,
    GridItem,
    Swipe,
    SwipeItem,
    List,
    PullRefresh,
    Loading,
    SwipeCell,
    Button,
    Image,
    Lazyload,
    Popup,
    Field,
    Icon,
    Checkbox,
    CheckboxGroup,
    SwitchCell,
    Cell,
    CellGroup,
    Stepper,
    DatetimePicker,
    Picker,
    Collapse,
    CollapseItem,
    ImagePreview,
    Col,
    Row
} from 'vant';
import 'vant/lib/index.css';
Vue.use(ActionSheet);
Vue.use(NavBar);
Vue.use(Overlay);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(NoticeBar);
Vue.use(Tab).use(Tabs);
Vue.use(Grid).use(GridItem);
Vue.use(Swipe).use(SwipeItem);
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Loading);
Vue.use(SwipeCell);
Vue.use(Button);
Vue.use(Image);
Vue.use(Popup);
Vue.use(Field);
Vue.use(Icon);
Vue.use(Checkbox).use(CheckboxGroup);
Vue.use(SwitchCell);
Vue.use(Cell).use(CellGroup);
Vue.use(Stepper);
Vue.use(DatetimePicker);
Vue.use(Picker);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(ImagePreview);
Vue.use(Col);
Vue.use(Row);
// 注册时可以配置额外的选项
Vue.use(Lazyload, {
    lazyComponent: true
});

// 基于有赞的自定义错误提示组件
import warningIco from '@/components/icon/Warning'
Vue.use(warningIco);
Vue.component('zb-warning', warningIco);